let activeSession = null

export const isSessionPreparing = () => activeSession !== null

// Reserve both participants before routing: mounted hooks can run after push().
export function beginSessionReadiness(timeout = 30000) {
  if (activeSession) activeSession.dispose()
  const pending = new Set(['navigation', 'dashboard'])
  const failures = []
  let resolveReady
  let finished = false
  const ready = new Promise((resolve) => { resolveReady = resolve })
  const finish = (timedOut = false) => {
    if (finished) return
    finished = true
    clearTimeout(timer)
    resolveReady({ timedOut, failures: [...failures] })
  }
  const timer = setTimeout(() => finish(true), timeout)
  const session = {
    ready,
    register(name) {
      if (!finished) pending.add(name)
    },
    settle(name, failed = false) {
      if (finished || !pending.has(name)) return
      if (failed) failures.push(name)
      pending.delete(name)
      if (!pending.size) finish()
    },
    dispose() {
      finish()
      if (activeSession === session) activeSession = null
    },
  }
  activeSession = session
  return session
}

export function trackSessionTask(name, load) {
  // Capture this session so a late response cannot release a subsequent login.
  const session = activeSession
  if (session) session.register(name)
  const task = Promise.resolve().then(load)
  task.then(
    () => { if (session) session.settle(name) },
    () => { if (session) session.settle(name, true) }
  )
  return task
}

// Vue forwards rejected lifecycle promises to Nuxt's full-page error handler.
// Initial section loads have a local error boundary: preserve the readiness
// failure and show a warning without discarding the rest of the application.
export function initializeSessionSection(vm, name) {
  const duringTransition = isSessionPreparing()
  return trackSessionTask(name, () => vm.init()).catch((error) => {
    console.error(`[Session initialization: ${name}]`, error && (error.stack || error.message))
    if (!duringTransition && !vm._isDestroyed) {
      vm.$store.commit('notification/show', {
        color: 'warning',
        text: vm.$t('session_initial_load_incomplete'),
        timeout: 8000,
      })
    }
  })
}
